import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import CompanyDetail from './components/CompanyDetails.vue';
let default_1 = class extends Vue {};
default_1 = __decorate([Component({
  name: 'ManageCompany',
  components: {
    CompanyDetail
  },
  props: ['isEdit']
})], default_1);
export default default_1;